module.exports = __webpack_public_path__ + "img/B4-20190410_06.e6e639dc.jpg";